import { PublicClientApplication } from "@azure/msal-browser";
import { createMsalInstance } from "./services/authenticationService";

let msalInstance: PublicClientApplication | null = null;

export default async () => {
    if (!msalInstance) {
        msalInstance = await createMsalInstance();
    }

    return msalInstance;
}
